import React from 'react';

import { useAppSelector } from 'redux/hooks';
import { Loader } from '..';
import {IframePage} from "../../types/iframe";
import {withParamsFrame} from "../../HOCs";

const BillingPurchase: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);
    const [loaded, setLoaded] = React.useState(false);

    const { accessToken } = useAppSelector(({ users }) => ({
        accessToken: users.currentUser.data.accessToken,
    }))

    return (
        <>  
            <div className="sm:pt-8 sm:pl-8">
                <iframe className={`${!loaded ? 'min-h-[auto]' : 'page-iframe-min'}`} src={`https://lk.market/billing/purchase${httpParams}`}
                    title="Billing purchase"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}

                    onLoad={() => setLoaded(true)}
                ></iframe>
            </div>
            {
                !loaded && <Loader />
            }
        </>
    );
};

export default withParamsFrame(BillingPurchase);
